import { Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Confirm from "./pages/confirm";
import NewsletterForm from './components/NewsletterForm';
import Mainpage from "./components/Mainpage";
import Webhosting from './pages/Webhosting';
import Emailhosting from './pages/Emailhosting';
import Aspnethosting from './pages/Aspnethosting';
import Storage from './pages/Storage';
import Dedicatedservers from './pages/Dedicatedservers';
import Vpscloud from './pages/Vpscloud';
import Windowsvps from './pages/Windowsvps';
import Contact from "./pages/Contact";
import ContactForm from "./pages/ContactForm";
import SubscribeForm from "./pages/SubscribeForm";
import UnsubscribeForm from "./pages/UnsubscribeForm";
import Policy from './pages/Policy' ;
import Terms from './pages/Terms' ;
import ScrollToTopButton from './components/ScrollToTopButton'

/*import Quote from "./components/Quote";
import InsuranceQuote from "./components/InsuranceQuote";*/

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      offset: 100, // offset (in px) from the original trigger point
      easing: "ease-in-out", // easing function
      once: true, // animation happens only once
    });
    AOS.refresh();
  }, []);
  return (
    <div className="container1 m-c1">

     <Header />
        <Routes>
          <Route path="/confirm" element={<Confirm />}/>
          <Route path="/" element={<Mainpage />} />
          <Route path="/Webhosting" element={<Webhosting />}/>
          <Route path="/Emailhosting" element={<Emailhosting />}/>
          <Route path ="/Aspnethosting" element ={<Aspnethosting />}/>
          <Route path ="/Storage" element ={<Storage />}/>
          <Route path ="/Dedicatedservers" element ={<Dedicatedservers />}/>
          <Route path ="/Vpscloud" element ={<Vpscloud />}/>
          <Route path ="/Windowsvps" element ={<Windowsvps />}/>
          <Route path ="/Contact" element ={<Contact />}/>
          <Route path ="/ContactForm" element ={<ContactForm />}/>
          <Route path ="/SubscribeForm" element ={<SubscribeForm />}/>
          <Route path ="/UnsubscribeForm" element ={<UnsubscribeForm />}/>
          <Route path="/Policy" element={<Policy />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path ="/NewsletterForm" element ={<NewsletterForm />}/>
          
          
          
        </Routes>
     <ScrollToTopButton />
      <Footer />

    </div>
  );
}

export default App;
